<script setup lang="ts">

import AuthenticatedLayout from "@/layout/AuthenticatedLayout.vue";
import PageHeader from "@/components/PageHeader.vue";
import ReportPeriodFilterBar from "@/components/Reporting/ReportPeriodFilterBar.vue";
import {useReportingStore} from "@/store/reporting";
import {ref, computed} from "vue";
import UsageSummaryMetricTiles from "@/pages/Insights/ReportsDetailPage/components/UsageSummaryMetricTiles.vue";
import PersonalityTraitsDistributionGraphs
  from "@/pages/Insights/ReportsDetailPage/components/PersonalityTraitsDistributionGraphs.vue";

const reportingStore = useReportingStore();
reportingStore.setAvailableFilters({
  tenants: true,
  institutions: true,
  cohorts: true,
  curriculum: false
});

const metric = ref();
const reportData = ref();
const showReport = ref(false);

const breadcrumbItems = computed(() => [
  {text: "Insights", to: {name: "reports"}},
  {text: "Personality Traits Distribution Report", to: null}
]);

async function runReport() {
  await fetchMetricData();
  await fetchReportData();
  showReport.value = true;
}

function resetReport() {
  metric.value = null;
  reportData.value = null;
  showReport.value = false;
}

async function fetchReportData() {
  reportData.value = await reportingStore.fetchReport("personality-traits-distribution");
}

async function fetchMetricData() {
  metric.value = await reportingStore.fetchReport("users-completed-big5-ratio");
}
</script>

<template>
  <authenticated-layout :back-route="{ name: 'reports' }" :breadcrumbs="breadcrumbItems">

    <page-header
      title="Personality Traits Distribution Report"
      description="Explore user the distribution of Personality Traits"
    />

    <ReportPeriodFilterBar
      :show-filters="true"
      :show-time-frame="false"
      :show-time-frame-switch="true"
      :show-run-report-button="true"
      @run-report="runReport"
      @reset-filters="resetReport"
    />

    <template v-if="showReport">
      <v-row>
        <v-col cols="12">
          <UsageSummaryMetricTiles
            :data="metric"
            category-title="Total Users"
            category-icon="fa fa-barcode"
            completed-label="Complete"
            pending-label="Incomplete"
            percentage-label="Completion Rate"
          />
        </v-col>
      </v-row>

      <PersonalityTraitsDistributionGraphs v-if="reportData" :report-data="reportData" />
    </template>
  </authenticated-layout>
</template>

<style scoped>

</style>
